/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-pascal-case */
import Top_User from "./Top_User.js";
import { useState,useEffect } from "react";
import {connect} from "react-redux";
import { requestTopUsers } from "../../redux/actions/actions.js";
import React from "react";

const Top_Users = (props) => {
    const [ option, setOption ] = useState("firstname");

    const handleChange = (event) => {
        props.onRequestTopUsers(event.target.value);
    }
    useEffect(() => {
        props.onRequestTopUsers(option);
    },[])
    return(
        <div className="right_top_users">
            <div className={`right_top_users_header background_change_${props.color_background}`}>
                <h1 className="right_top_users_title">Top accounts</h1>
                <select className={`right_top_users_select background_color_text_${props.color_background}`} onChange={handleChange} >
                    {/* <option value="followers">Followers</option> */}
                    <option value="firstname">First name</option>
                    <option value="lastname">Last name</option>
                    <option value="username">User name</option>
                </select>
            </div>
            <div className={`right_top_users_div background_change_${props.color_background}`}>
                {
                    props.top_users.map(user => {
                        return(
                            <Top_User 
                                key={user.id} 
                                firstName={user.firstName} 
                                lastName={user.lastName} 
                                userName={user.userName} 
                                id={user.id} 
                            />
                        )
                    })
                }
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_button: state.getColorButton.color_button,
        color_background: state.getColorBackground.color_background,
        user: state.getUser.user,
        top_users: state.requestTopUsers.top_users
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onRequestTopUsers: (text) => dispatch(requestTopUsers(text))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Top_Users);